import React from 'react'
import ClipLoader from "react-spinners/ClipLoader"
import { Link } from 'react-router-dom'

class Teacher extends React.Component
{
    submit = (event) =>
    {
        event.preventDefault()
        this.props.submit()
    }

    render()
    {
        var { submitting } = this.props
        return (
            <form class = "form-horizontal form-validate" novalidate method = "post" action = "/account/log-in/teacher" onSubmit={this.submit}>
                <div class = "form-group row">
                    <label for = "username" class = "d-none d-sm-inline col-sm-3 control-label text-right">Username</label>
                    
                    <div class = "col-sm-6">
                        <input type = "text" disabled = {submitting} class = "form-control" id = "username" name = "username" placeholder = "Username" required data-description = "enter your username" autofocus />
                    </div>
                </div>
                
                <div class = "form-group row">
                    <label for = "password" class = "d-none d-sm-inline col-sm-3 control-label text-right">Password</label>
                    
                    <div class = "col-sm-6">
                        <input type = "password" disabled = {submitting} class = "form-control string" id = "password" name = "password" placeholder = "Password" required data-type = "password" minlength = "5" data-description = "enter your password" />
                    </div>
                </div>
                
                <button type = "submit" id = "login-submit" disabled = {submitting} class = "btn btn-secondary btn-lg">
                    {submitting ? <ClipLoader
                            size={20}
                            color={"#123abc"}
                            loading={submitting}
                            /> : "Log In"}</button>
                
                
                <div class = "form-group row">
                    <p className = "medium-small col-12"><Link to = "/account/recover">Forgot my password</Link></p>
                    
                    <p className = "col-12"><Link to = "/account/sign-up">Need an Account? <strong>Sign up here!</strong></Link></p>
                </div>
            </form>
        )
    }
}

export default Teacher
